import useProjectDetail from "@/api/query/useProjectDetailQuery";
import { AssignedUsers } from "@/api/query/useProjectQuery";
import Loader from "@/components/common/Loader";
import { useUser } from "@/hooks/useUser";
import {
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { Button } from "@/components/ui/button";
import { toast } from "react-toastify";
import useRemoveProjectMemberMutation from "@/api/mutation/useRemoveMemberProject";
import Dialog from "@/components/common/Dialog";
import Table, { ColumeDef } from "@/components/shared/Table";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { CheckIcon, Settings } from "lucide-react";
import InputText from "@/components/common/InputText";
import CrossIcon from "@/assets/svg/CrossIcon.svg";
import InputSelect from "react-select";
import useDebounce from "@/hooks/useDebounce";
import useOrganisationDetailsQuery, {
  UserOrganisationType,
} from "@/api/query/useOrganisationDetailsQuery";
import z from "zod";
import { addUserIntoProject } from "@backend/src/schemas/projectSchema";
import useAssignUserToProjectMutation from "@/api/mutation/useAssignUserToProjectMutation";
import { reAssginedTaskSchema } from "@backend/src/schemas/organisationSchema";
import UserAvatar from "@/components/ui/userAvatar";
import { cn } from "@/lib/utils";
import useReAssgingTasktoMemberMutation from "@/api/mutation/useReAssingTasktoMember";
import { errorConfig } from "@/lib/toastError";
import useProjectMemberJobTitleMutation from "@/api/mutation/useProjectJobTitleUpdateMutation";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { enumToString } from "@backend/src/utils/enumToString";
const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    zIndex: 1000,
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
} as const;
function ProjectMember() {
  const [isAddProjectMembers, setIsAddProjectMembers] = useState(false);

  const [reAssing, setReAssign] = useState(false);
  const [reAssingUser, setReAssignUser] = useState<
    z.infer<typeof reAssginedTaskSchema> & { projectId?: string }
  >();
  const { t } = useTranslation();
  const { projectId } = useParams();
  const projectDetailQuery = useProjectDetail(projectId, true);
  const [assignedUsers, setAssignedUsers] = useState<
    AssignedUsers[] | undefined
  >();
  const [orgAssignedUsers, setOrgAssignedUsers] = useState<
    UserOrganisationType[] | undefined
  >();
  const [userId, setUserId] = useState<string>();
  const [userRole, setUserRole] = useState<string>();
  const addOrganisationMemberMutation = useOrganisationDetailsQuery(
    localStorage.getItem("organisation-id") + ""
  );
  const assignProjectAndRoleToUserMutation = useAssignUserToProjectMutation();
  useEffect(() => {
    setAssignedUsers(projectDetailQuery.data?.data.data.assignedUsers);
  }, [
    projectDetailQuery.data?.data.data,
    addOrganisationMemberMutation.data?.data.data
  ]);
  useEffect(() => {
    setOrgAssignedUsers(
      addOrganisationMemberMutation.data?.data.data.userOrganisation
    );
  }, [addOrganisationMemberMutation.data?.data.data, assignedUsers]);
  const [filterString, setFilterString] = useDebounce("", 400);
  const [filterStringForOrganisation, setFilterStringForOrganisation] =
    useDebounce("", 400);
  useEffect(() => {
    setFilterStringForOrganisation("")
    setFilterString("")
  }, [isAddProjectMembers])
  
  useEffect(() => {
    if (filterString) {
      const stringToFilter = filterString.toLowerCase();
      setAssignedUsers(
        projectDetailQuery.data?.data.data.assignedUsers.filter((o) => {
          return (
            String(o.user.firstName).toLowerCase().includes(stringToFilter) ||
            String(o.user.lastName).toLowerCase().includes(stringToFilter) ||
            String(o.user.email).toLowerCase().includes(stringToFilter)
          );
        })
      );
    } else {
      setAssignedUsers(projectDetailQuery.data?.data.data.assignedUsers);
    }
  }, [filterString, projectDetailQuery.data?.data.data, assignedUsers]);
  useEffect(() => {
    if (filterStringForOrganisation) {
      const stringToFilter = filterStringForOrganisation.toLowerCase();
      setOrgAssignedUsers(
        addOrganisationMemberMutation.data?.data.data.userOrganisation
          .filter((o) => {
            return (
              String(o.user.firstName).toLowerCase().includes(stringToFilter) ||
              String(o.user.lastName).toLowerCase().includes(stringToFilter) ||
              String(o.user.email).toLowerCase().includes(stringToFilter)
            );
          })
      );
    } else {
      setOrgAssignedUsers(
        addOrganisationMemberMutation.data?.data.data.userOrganisation
      );
    }
  }, [filterStringForOrganisation]);
  const [remove, setRemove] = useState<string>();
  const { user } = useUser();
  const verification = () => {
    if (user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR) {
      return true;
    } else if (
      projectDetailQuery.data?.data.data.assignedUsers.some((item) => {
        return (
          item.projectRole === UserRoleEnumValue.PROJECT_MANAGER &&
          item.user.userId == user?.userId
        );
      })
    ) {
      return true;
    }

    return false;
  };
  const isAdmin = verification();
  user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR;
  const removeProjectMemberMutation = useRemoveProjectMemberMutation();
  const removeMembers = (id: string) => {
    removeProjectMemberMutation.mutate(id, {
      onSuccess(data) {
        projectDetailQuery.refetch();
        toast.success(data.data.message);
        setRemove(undefined);
      },
      onError(error) {
        if (
          error.response?.data.message ==
          "There are ongoing tasks assigned to the user!"
        ) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
          setReAssign(true);
        } else {
          setRemove(undefined);
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        }
      },
    });
  };
  const currentUserIsAdmin =
    user?.userOrganisation.find(
      (org) => org.organisationId === localStorage.getItem("organisation-id")
    )?.role === UserRoleEnumValue.ADMINISTRATOR;

  const [checked, setChecked] = useState<z.infer<typeof addUserIntoProject>>();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setChecked((prev) => {
        const newState = prev ? [...prev] : []; // Ensure prev is an array or initialize an empty array
        newState.push({
          userId: e.target.name,
          userRoleForProject: UserRoleEnumValue.TEAM_MEMBER,
        });
        return newState;
      });
    } else {
      setChecked(checked?.filter((c) => c.userId !== e.target.name));
    }
  };
  const allowed = (assigneduser: AssignedUsers) => {
    // Check if the current user is an Administrator or Project Manager on the project
    const isAdmin =
      user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR;

    const isProjectManagerOnTheProject =
      projectDetailQuery.data?.data.data.assignedUsers.some(
        (u) =>
          u.user.userId == user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER
      );

    const isTeamMember = projectDetailQuery.data?.data.data.assignedUsers.some(
      (u) =>
        u.user.userId == user?.userId &&
        u.projectRole == UserRoleEnumValue.TEAM_MEMBER
    );

    // If the user is an Admin, allow them to proceed
    if (isAdmin) {
      return false; // Admins can do everything, so return false (allow)
    }

    // If the user is a Project Manager, only allow them to proceed for themselves
    else if (isProjectManagerOnTheProject) {
      // Only allow removing or editing the current PM, not anyone else
      if (assigneduser.user.userId == user?.userId) {
        return true; // Project Manager can only edit themselves
      } else {
        return false; // Prevent removing other users
      }
    }

    // If the user is a Team Member, don't allow them to remove anyone
    else if (isTeamMember) {
      return true; // Team Members cannot remove others
    }

    // Otherwise, deny access (for users who are neither Admins, PMs, nor Team Members)
    return true;
  };

  const columnDef: ColumeDef[] = [
    {
      header: t("full_name"),
      key: "firstname",
      onCellRender: (user: AssignedUsers) => {
        return (
          <div className="flex w-full items-center gap-1.5">
            <UserAvatar user={user.user} />
            <div className="text-base font-normal text-gray-450">
              {user.user.firstName && user.user.lastName ? (
                <>{user.user.firstName + " " + user.user.lastName}</>
              ) : (
                "-"
              )}
            </div>
            <div
              className="rounded-md bg-primary-400/50 
            text-[10px] px-1  flex justify-center items-center text-primary-900 font-semibold"
            >
              {user.projectRole == UserRoleEnumValue.ADMINISTRATOR
                ? "Admin"
                : user.projectRole == UserRoleEnumValue.PROJECT_MANAGER
                  ? "PM"
                  : user.projectRole == UserRoleEnumValue.COLLABORATOR
                    ? "CO"
                    : "TM"}
            </div>
            {/* {user.user.firstName && user.user.lastName
              ? {<div></div>}
              : "-"} */}
          </div>
        );
      },
    },
    {
      header: t("email"),
      key: "email",
      onCellRender: (user: AssignedUsers) => {
        return <div className="text-left w-full">{user.user.email}</div>;
      },
    },
    {
      header: "Initial",
      key: "initial",
      onCellRender: (user: AssignedUsers) => {
        return (
          <div>
            {user.user.firstName
              ? user.user.lastName
                ? `${user.user.firstName.charAt(0)}${user.user.lastName.charAt(
                  0
                )}`.toUpperCase()
                : `${user.user.firstName.charAt(0)}${user.user.firstName.charAt(
                  1
                )}`.toUpperCase()
              : `${user.user.email.charAt(0)}${user.user.email.charAt(
                1
              )}`.toUpperCase()}
          </div>
        );
      },
    },
    // {
    //   header: "Role",
    //   key: "role",
    //   onCellRender: (user: AssignedUsers) => {
    //     return (
    //       <div>
    //         {user.user.userOrganisation[0].role
    //           .toLowerCase()
    //           .replace(/_/g, " ")
    //           .replace(/\b\w/g, (char) => char.toUpperCase())}
    //       </div>
    //     );
    //   },
    // },
    {
      header: t("role_in_the_project"),
      key: "role",
      onCellRender: (user: AssignedUsers) => {
        // return (
        //   <div>
        //     {user.projectRole
        //       ? user.projectRole
        //           .toLowerCase()
        //           .replace(/_/g, " ")
        //           .replace(/\b\w/g, (char) => char.toUpperCase())
        //       : "N/A"}
        //   </div>
        // );
        return <div>{user.projectJobTitle ?? "N/A"}</div>;
      },
    },
    // {
    //   header: "Job title",
    //   key: "email",
    //   onCellRender: (user: AssignedUsers) => {
    //     return <div>{user.user.userOrganisation[0].jobTitle ?? "N/A"}</div>;
    //   },
    // },
    {
      header: t("actions"),
      key: "projectId",
      onCellRender: (userInRow: AssignedUsers) => {
        return (
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <div className="cursor-pointer w-24 h-8 px-3 py-1.5 bg-white border rounded justify-center items-center gap-px inline-flex">
                  <Settings className="mr-2 h-4 w-4" />
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-24 !z-10  flex flex-col gap-1 bg-white shadow rounded">
                <DropdownMenuItem className="w-full flex  items-center">
                  <Button
                    disabled={
                      !(
                        assignedUsers?.some(
                          (d) =>
                            (d.projectRole ==
                              UserRoleEnumValue.PROJECT_MANAGER ||
                              d.projectRole ==
                                UserRoleEnumValue.ADMINISTRATOR) &&
                            user?.userId == d.user.userId
                        ) ||
                        user?.userOrganisation[0]?.role ===
                          UserRoleEnumValue.ADMINISTRATOR
                      )
                    }
                    variant={"none"}
                    className="flex w-full justify-start"
                    onClick={() => {
                      setUserId(userInRow.user.userId),
                      setUserRole(userInRow.projectJobTitle ?? "");
                    }}
                  >
                    <Settings className="mr-0.5 h-4 w-4" />
                    Role
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem className="w-full flex items-center">
                  <Button
                    variant={"none"}
                    className="flex justify-start w-full"
                    disabled={allowed(userInRow)}
                    onClick={() => {
                      setRemove(
                        assignedUsers?.find(
                          (id) => id.user.userId == userInRow.user.userId
                        )?.projectAssignUsersId ?? ""
                      );
                    }}
                  >
                    <img src={TrashCan} alt="" />
                    Remove
                  </Button>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        );
      },
    },
  ];

  const userFinded = (data: UserOrganisationType) => {
    return assignedUsers?.some((d) => d.user.userId == data.user.userId);
  };

  const submit = (UserRole: keyof typeof UserRoleEnumValue) => {
    const data = {
      projectId: projectId ?? "",
      data:
        checked?.map((t) => {
          return { ...t, userRoleForProject: UserRole };
        }) ?? [],
    };
    if (checked && checked.length > 0) {
      assignProjectAndRoleToUserMutation.mutate(data, {
        onSuccess(data) {
          toast.success(data.data.message);
          projectDetailQuery.refetch();
          addOrganisationMemberMutation.refetch();
          setIsAddProjectMembers(false);
          setChecked(undefined);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };
  const orgColumnDef: ColumeDef[] = [
    {
      header: "",
      key: "firstname",
      className: (user: UserOrganisationType) =>
        `${userFinded(user) ? "bg-gray-300/30" : ""}`,
      onCellRender: (user: UserOrganisationType) => {
        return (
          <div>
            {!userFinded(user) && (
              <input
                type="checkbox"
                disabled={userFinded(user)}
                checked={checked?.some((e) => e.userId == user.user.userId)}
                name={user.user.userId}
                onChange={(e) => handleChange(e)}
              />
            )}
            {userFinded(user) && (
              <input
                type="checkbox"
                disabled={userFinded(user)}
                checked={true}
                name={user.user.userId}
                onChange={(e) => handleChange(e)}
              />
            )}
          </div>
        );
      },
    },
    {
      header: t("full_name"),
      key: "firstname",
      className: (user: UserOrganisationType) =>
        `${userFinded(user) ? "bg-gray-300/30" : ""}`,
      onCellRender: (user: UserOrganisationType) => {
        return (
          <div>
            {" "}
            {user.user.firstName && user.user.lastName
              ? ` ${user.user.firstName} ${user.user.lastName}`
              : "-"}
          </div>
        );
      },
    },
    {
      header: t("email"),
      key: "email",
      className: (user: UserOrganisationType) =>
        `${userFinded(user) ? "bg-gray-300/30" : ""}`,
      onCellRender: (user: UserOrganisationType) => {
        return <div>{user.user.email}</div>;
      },
    },
    {
      header: t("initial"),
      key: "initial",
      className: (user: UserOrganisationType) =>
        `${userFinded(user) ? "bg-gray-300/30" : ""}`,
      onCellRender: (user: UserOrganisationType) => {
        return (
          <div>
            {user.user.firstName
              ? user.user.lastName
                ? `${user.user.firstName.charAt(0)}${user.user.lastName.charAt(
                  0
                )}`.toUpperCase()
                : `${user.user.firstName.charAt(0)}${user.user.firstName.charAt(
                  1
                )}`.toUpperCase()
              : `${user.user.email.charAt(0)}${user.user.email.charAt(
                1
              )}`.toUpperCase()}
          </div>
        );
      },
    },
    {
      header: t("job_title"),
      key: "email",
      className: (user: UserOrganisationType) =>
        `${userFinded(user) ? "bg-gray-300/30" : ""}`,
      onCellRender: (user: UserOrganisationType) => {
        return <div>{user.role ?? "N/A"}</div>;
      },
    },
  ];

  const getOptions = () => {
    const data = [{ label: "Select role in the project", value: "" }];
    user?.userOrganisation[0].organisation.jobTitlesOfOrg?.forEach((d) => {
      data.push({ label: d, value: d });
    });

    return data;
  };
  const projectMemberJobTitleMutation = useProjectMemberJobTitleMutation();
  const submitRole = () => {
    const data = {
      assingprojectId: assignedUsers?.find((u) => u.user.userId == userId)
        ?.projectAssignUsersId,
      projectJobTitle: userRole,
    };

    projectMemberJobTitleMutation.mutate(
      {
        assingprojectId: data.assingprojectId,
        projectJobTitle: data.projectJobTitle,
      },
      {
        onSuccess(data) {
          toast.success(data.data.message);
          projectDetailQuery.refetch();
          setUserId(undefined);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  const reAssgingTaskMutation = useReAssgingTasktoMemberMutation();

  const handleReAssign = () => {
    if (reAssingUser) {
      reAssgingTaskMutation.mutate(reAssingUser, {
        onSuccess(data) {
          if (reAssingUser.projectId) {
            // handleRemoveMember(reAssingUser.organisationUserId);
            removeMembers(remove ?? "");
          }
          toast.success(data.data.message);
          setReAssignUser(undefined);
          setReAssign(false);
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                "You are not authorized to edit tasks which are not assigned to you"
              )
              : error.response?.data.message,
            errorConfig
          );
        },
      });
    }
  };

  return (
    <div className=" relative flex-1">
      {projectDetailQuery.isFetching ? (
        <Loader />
      ) : (
        <>
          <div className={`mt-1 overflow-auto h-full ${`ml-4`}`}>
            {!isAddProjectMembers && (
              <div className=" w-full h-[85%] p-3">
                <div className="text-gray-400 text-lg  font-semibold ">
                  {t("project_members")}
                </div>
                <div className="mb-3 flex justify-between  mt-5">
                  <div>
                    <InputText
                      name="search filter"
                      id="search-filter"
                      placeholder={t("filter_by_name_and_email")}
                      className="mt-0 h-auto sm:w-fit max-w-full"
                      onChange={(event) => setFilterString(event.target.value)}
                    />
                  </div>
                  <div>
                    {/* Org Admins */}
                    {currentUserIsAdmin && (
                      <div className="flex items-center justify-end gap-2 mr-3">
                        {!isAddProjectMembers && isAdmin && (
                          <div className="flex items-center justify-end mr-3">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => setIsAddProjectMembers(!isAddProjectMembers)}
                            >
                              {t("add_project_members")}
                            </Button>
                          </div>
                        )}
                        <Link
                          to={`/organisation/${localStorage.getItem("organisation-id")}`}
                          state={{ open: true }}
                        >
                          <Button variant="primary_outline" size="sm">
                            {t("invite_new_member")}
                          </Button>
                        </Link>
                      </div>
                    )}
                    {/* Project Managers (but not org admins) */}
                    {!currentUserIsAdmin && isAdmin && (
                      <div className="flex items-center justify-end mr-3">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => setIsAddProjectMembers(!isAddProjectMembers)}
                        >
                          {t("add_project_members")}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="h-[80%]">
                  <Table
                    columnDef={columnDef}
                    data={assignedUsers ?? []}
                    className="!p-0"
                    onRowClassName={(data) => {
                      return !data.user.isActive
                        ? "opacity-70 bg-gray-400/30  cursor-not-allowed"
                        : "";
                    }}
                  />
                </div>
              </div>
            )}
            {isAddProjectMembers && isAdmin && (
              <div className="w-full p-3 h-[85%]">
                <div className="text-gray-400 text-lg  font-semibold mb-3">
                  {t("organization_members")}
                </div>
                <div className="mb-3 flex justify-between">
                  <div className="flex gap-2 items-end">
                    <InputText
                      name="search filter"
                      id="search-filter"
                      placeholder={t("filter_by_name_and_email")}
                      className="mt-0 h-auto sm:w-fit max-w-full"
                      onChange={(event) =>
                        setFilterStringForOrganisation(event.target.value)
                      }
                    />
                    {user?.userOrganisation[0]?.role !==
                      UserRoleEnumValue.ADMINISTRATOR && (
                      <p className="text-sm text-red-500 font-semibold">
                        {t("error_message_for_pm")}
                      </p>
                    )}
                  </div>
                  <div>
                    {(currentUserIsAdmin || isAdmin) && (
                      <div className="flex items-center gap-3">
                        <Button
                          variant={"destructive"}
                          size={"sm"}
                          onClick={() => setIsAddProjectMembers(false)}
                        >
                          {t("cancel")}
                        </Button>{" "}
                        <DropdownMenu>
                          <DropdownMenuTrigger
                            asChild
                            disabled={!(checked && checked.length > 0)}
                          >
                            <div>
                              <Button
                                variant={
                                  !(checked && checked.length > 0)
                                    ? "primary_outline"
                                    : "primary"
                                }
                                disabled={!(checked && checked.length > 0)}
                              >
                                {t("assign_to_project")}
                              </Button>
                            </div>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent>
                            <DropdownMenuItem>
                              <Button
                                variant={"none"}
                                size={"sm"}
                                disabled={!(checked && checked.length > 0)}
                                onClick={() => {
                                  submit(UserRoleEnumValue.TEAM_MEMBER);
                                }}
                              >
                                {t(enumToString(UserRoleEnumValue.TEAM_MEMBER))}
                              </Button>
                            </DropdownMenuItem>
                            <DropdownMenuItem>
                              <Button
                                variant={"none"}
                                size={"sm"}
                                disabled={!(checked && checked.length > 0)}
                                onClick={() => {
                                  submit(UserRoleEnumValue.COLLABORATOR);
                                }}
                              >
                                {t("Read Only")}
                              </Button>
                            </DropdownMenuItem>
                          </DropdownMenuContent>
                        </DropdownMenu>
                      </div>
                    )}
                  </div>
                </div>
                <div className="h-[90%]">
                  <Table
                    className="!px-0"
                    columnDef={orgColumnDef}
                    data={orgAssignedUsers ?? []}
                  ></Table>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      {/* {currentUserIsAdmin && (
        <Dialog
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          hasEscClose={true}
          modalClass="sm:rounded-lg p-4 h-full md:h-auto w-full max-w-md"
        >
          <div>
            <div className="text-xl">Add Member</div>
            <Button
              onClick={() => setIsOpen(false)}
              variant={"ghost"}
              size={"icon"}
              className="absolute top-1 right-1"
            >
              <img src={CrossIcon}></img>
            </Button>
            <form onSubmit={addOrgMemberForm.handleSubmit}>
              <div>
                <FormLabel htmlFor="email">Member Email</FormLabel>
                <InputEmail
                  name="email"
                  id="email"
                  placeholder="Enter member email"
                  value={addOrgMemberForm.values.email}
                  onChange={addOrgMemberForm.handleChange}
                />
                <ErrorMessage>
                  {addOrgMemberForm.touched.email &&
                    addOrgMemberForm.errors.email}
                </ErrorMessage>
              </div>
              <div>
                <FormLabel htmlFor="role">Role</FormLabel>
                <InputSelect
                  onChange={(val) => {
                    if (val) {
                      const selectedRole =
                        val as (typeof memberRoleOptions)[number];
                      const selectedRoleValue = selectedRole?.value;
                      setSelectedRole(selectedRole);
                      addOrgMemberForm.setFieldValue("role", selectedRoleValue);
                    }
                  }}
                  onBlur={addOrgMemberForm.handleBlur}
                  options={memberRoleOptions}
                  value={selectedRole}
                  placeholder="Select role"
                  name="role"
                  id="role"
                />
                <ErrorMessage>
                  {addOrgMemberForm.touched.role &&
                    addOrgMemberForm.errors.role}
                </ErrorMessage>
              </div>
              <div className="text-right">
                <Button
                  variant={"primary"}
                  type="submit"
                  isLoading={isAddOrgMemberSubmitting}
                  disabled={isAddOrgMemberSubmitting}
                >
                  Add
                </Button>
              </div>
            </form>
          </div>
        </Dialog>
      )} */}

      <Dialog
        isOpen={Boolean(remove)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("remove_member_project_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeProjectMemberMutation.isPending}
              disabled={removeProjectMemberMutation.isPending}
              onClick={() => setRemove(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={() => {
                const userId = assignedUsers?.find(
                  (d) => d.projectAssignUsersId == remove
                )?.user.userId;
                removeMembers(remove ?? "");
                setReAssignUser((prev) => ({
                  oldUserId: userId ? [userId] : [""],
                  newUserId: prev?.newUserId ?? "",
                  projectId: projectId,
                }));
              }}
            >
              {t("remove")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(userId)}
        onClose={() => {}}
        modalClass="rounded-lg  overflow-visible"
      >
        <div className="flex flex-col gap-2 p-6 w-80">
          <div className="flex justify-between items-center ">
            {t("assign_role_in_the_project")}
            <img
              src={CrossIcon}
              className="w-4 h-4 cursor-pointer"
              onClick={() => setUserId(undefined)}
            />
          </div>
          <InputText
            value={
              assignedUsers?.find((u) => u.user.userId == userId)?.user.email
            }
            disabled
          />
          {user?.userOrganisation[0]?.organisationId && (
            <div className="z-40">
              <InputSelect
                name="jobTitle"
                options={getOptions()}
                placeholder={t("role")}
                onChange={(e) => {
                  if (e) {
                    setUserRole(e?.value);
                  }
                }}
                defaultValue={getOptions().find((d) => d.value == userRole)}
                menuPlacement="auto"
                className="z-10"
                styles={reactSelectStyle}
              />
              <div>
                {user.userOrganisation[0].role &&
                  user.userOrganisation[0].role ==
                    UserRoleEnumValue.ADMINISTRATOR && (
                  <Link
                    className="text-primary-500 text-xs underline underline-offset-1"
                    to={`/organisation/${user?.userOrganisation[0].organisationId}`}
                  >
                    {t("Manage the list of roles")}
                  </Link>
                )}
                {!user.userOrganisation[0].role && getOptions().length <= 1 && (
                  <div className="text-xs">
                    {t(
                      "Please ask your admin to create the list of job titles"
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeProjectMemberMutation.isPending}
              disabled={removeProjectMemberMutation.isPending}
              onClick={() => setUserId(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button variant={"primary"} onClick={() => submitRole()}>
              {t("save")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={reAssing}
        onClose={() => {
          setReAssign(false);
          setReAssignUser(undefined);
        }}
        hasEscClose={true}
        modalClass="sm:rounded-lg p-4 h-full md:h-auto w-full max-w-md"
      >
        <div className="flex flex-col">
          <div className="text-lg font-semibold text-gray-600">
            {t("task_reassign_to_other_user")}
          </div>
          <div className="border rounded-md border-gray-100 mt-3 ">
            {assignedUsers
              ?.filter((d) => d.projectAssignUsersId !== remove)
              .map((userOrg) => {
                return (
                  // reAssingUser?.oldUserId != userOrg.user.userId && (
                  reAssingUser?.oldUserId.some((d) => d !== userOrg.user.userId) && (
                    <>
                      <div
                        key={
                          userOrg.user.userOrganisation[0].userOrganisationId
                        }
                        className={`flex flex-wrap md:flex-nowrap items-center px-2 py-1.5 sm:px-5 sm:py-3 gap-9 hover:bg-slate-50 ${
                          userOrg.user.userId === reAssingUser?.newUserId &&
                          "bg-slate-100"
                        }`}
                        onClick={() => {
                          setReAssignUser((prev) => ({
                            oldUserId: prev?.oldUserId ?? [""],
                            newUserId: userOrg.user.userId,
                            projectId: prev?.projectId ?? "",
                          }));
                        }}
                      >
                        <div
                          className={`flex w-full sm:w-auto gap-2 items-center grow ${
                            currentUserIsAdmin ? "cursor-pointer" : ""
                          }`}
                        >
                          <div className="relative">
                            <CheckIcon
                              className={cn(
                                "ml-auto w-full h-full rounded-full text-base absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-slate-200/70 ",
                                userOrg.user.userId === reAssingUser?.newUserId
                                  ? "opacity-100"
                                  : "opacity-0"
                              )}
                            />
                            <UserAvatar
                              user={userOrg.user}
                              className="min-w-8"
                            ></UserAvatar>
                          </div>
                          <div className="text-sm">
                            <div className="text-slate-800 font-medium">
                              {userOrg.user.firstName ?? ""}{" "}
                              {userOrg.user.lastName ?? ""}
                            </div>
                            <div className="text-gray-400">
                              {userOrg.user.email}
                            </div>
                          </div>
                          <div className="w-full h-full">
                            {userOrg.user.firstName
                              ? userOrg.user.lastName
                                ? `${userOrg.user.firstName.charAt(
                                  0
                                )}${userOrg.user.lastName.charAt(
                                  0
                                )}`.toUpperCase()
                                : `${userOrg.user.firstName.charAt(
                                  0
                                )}${userOrg.user.firstName.charAt(
                                  1
                                )}`.toUpperCase()
                              : `${userOrg.user.email.charAt(
                                0
                              )}${userOrg.user.email.charAt(
                                1
                              )}`.toUpperCase()}
                          </div>
                        </div>
                        <div className="capitalize text-gray-700 text-sm">
                          {userOrg.user.userOrganisation[0]?.role
                            ?.toLowerCase()
                            .replaceAll("_", " ")}
                        </div>
                      </div>
                      <hr className="h-px w-[98%] my-1 mx-auto bg-gray-200 border-0 " />
                    </>
                  )
                );
              })}
          </div>
          <div className="text-sm text-gray-400">
            {t("pending_task_popup_message")}
          </div>
          <div className="flex justify-end gap-2">
            <Button
              size={"sm"}
              variant={"destructive"}
              onClick={() => {
                setReAssign(false);
                setReAssignUser(undefined);
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              size={"sm"}
              variant={"primary"}
              onClick={() => handleReAssign()}
            >
              {t("submit")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ProjectMember;
